import * as CryptoJS from 'crypto-js'
import { BaseClientConfig } from '@news-mono/web-common'

export interface ManageAccountRequestBody {
    email: string
    userId: string
    given_name?: string
    family_name?: string
    current_password?: string // Encrypted string
    new_password?: string // Encrypted string
    new_email?: string
    plain_password?: string
    plain_new_password?: string
    newsletterSignup?: boolean
}

/* The Nightly Myaccount Action Paths */
export const getTheNightlyEmailVerifyActionPath =
    '/connect/manage-account/verify-email'
export const getTheNightlyUpdateEmailActionPath =
    '/connect/manage-account/update-email'
export const getTheNightlyUpdateNameActionPath =
    '/connect/manage-account/update-username'
export const getTheNightlyUpdatePasswordActionPath =
    '/connect/manage-account/update-password'
export const getTheNightlyVerifyPasswordActionPath =
    '/connect/manage-account/verify-password'
export const getTheNightlyDeleteAccountActionPath =
    '/connect/manage-account/delete-account'
export const getTheNightlyForgotPasswordActionPath =
    '/connect/manage-account/forgot-password'
export const getTheNightlyUpdateAppMetaActionPath =
    '/connect/manage-account/update-app-meta'

export async function encryptPass(
    passToEncrypt: string,
    passEncryptionKey: BaseClientConfig['passEncryptionKey'],
) {
    if (!passEncryptionKey || !passToEncrypt) {
        console.log('No key or password found')
        return
    }

    if (passEncryptionKey && passToEncrypt) {
        try {
            const encryptedPass = CryptoJS.AES.encrypt(
                passToEncrypt,
                passEncryptionKey,
            ).toString()

            console.log('successfully encrypted')
            return encryptedPass
        } catch (e) {
            console.log('error encrypting password', { err: e })
            return
        }
    }
}
